import { useState } from "react";
import type { ChangeEvent } from "react";

/*
 * Handles state management for form inputs
 */
export const useFormInput = (initialValue?: string) => {
  const [value, setValue] = useState(initialValue || "");
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValue(e.target.value);
  };

  return {
    value,
    onChange: handleChange,
    /** Sets the field directly, e.g. to clear it after a successful submit. */
    setValue
  };
};
